import { INITIAL_WOW_DELAY } from '../constants/variables';

export const dataWowDelayHandler = (number) => {
  let aux = INITIAL_WOW_DELAY + number;
  return `${aux}s`;
};
